export default __webpack_public_path__ + "static/media/cx_cover_fsc45.3b9f4070.jpeg";